interface ListBlock {
  items: ListItem[];
  extraInfo?: { text: string };
}

interface ListItem {
  icon?: string;
  body?: string;
  title?: string;
}

interface ListItemV2 {
  icon?: string;
  body?: string;
  title?: string;
  id?: string;
}

interface ListBlockV2 {
  items: ListItemV2[];
  extraInfo?: { text: string };
}

interface TitleGroup {
  icon?: string;
  title?: string;
  subtitle?: string;
}

interface InfoLink {
  external?: boolean;
  text?: string;
  url?: string;
  partnerName?: string;
  partnerType?: string;
}

// V1 API response type
type GreenlightView = {
  titleGroup: TitleGroup;
  infoLink?: InfoLink;
  listBlock?: ListBlock;
  preCheckTitle?: string;
  summaryGroup?: { title: string; summaries: string[] };
  button?: { title: string; action: string; external: boolean };
};

export type ReportInfo = { buttonText: string; reportType: ReportType };
// V2 API response type
type GreenlightV2 = {
  reportInfo?: ReportInfo;
  titleGroup: TitleGroup;
  infoLink?: InfoLink;
  listBlock?: ListBlockV2;
};

const REPORT_TYPES = {
  FREE_REPORT: 'FREE_REPORT',
  COMPLETE_REPORT: 'COMPLETE_REPORT',
} as const;

type ReportType = (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];

export { REPORT_TYPES };

export type {
  ListBlock,
  ListBlockV2,
  ListItem,
  TitleGroup,
  InfoLink,
  GreenlightView,
  GreenlightV2,
  ReportType,
};
